import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiNoticeService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import { DtgNoticeFormComponent } from "../form/dtg.notice.form.component";

@Component({
    selector: "dtg-notice-list"
    ,templateUrl: './dtg.notice.list.component.html'
    ,providers: []
})
export class DtgNoticeListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    listNotice:any[];
    @Input() listType:DtgListType = DtgListType.list;
    @Output() carInfo = new EventEmitter();
    searchValue:string;
    noticeType:string;
    noticeTarget:string;
    userGroupId:number = 99999;
    dtgTeamId:string = "";
    dtgTeamNm:string;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        if(this.currentUserInfo){
            this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
            if(this.userGroupId > 100){
                this.dtgTeamId = this.currentUserInfo.teamId;
            }
        }
        this.pagingInfo.pageSize = 15;
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickSearch(){
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    reloadListItem(){
        let searchInfo = {
            noticeType : this.noticeType
            ,noticeTarget : this.noticeTarget
            ,createDt : null
            ,searchValue : this.searchValue
        };
        this.fvmsApiNoticeService.getListNotice(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listNotice = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickOpenModalNoticeInfo(dtgActionType:DtgActionType,noticeInfo:any){
        let modalRef = this.modalService.open(
            DtgNoticeFormComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.noticeId = noticeInfo.noticeId;
        modalRef.componentInstance.noticeInfo = noticeInfo;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }
}